<template>
  <div
    class="site-wrapper"
    :class="{ 'site-sidebar--fold': sidebarFold }"
    v-loading.fullscreen.lock="loading"
    element-loading-text="拼命加载中">
    <template v-if="!loading" style="margin-bottom:100px;">
      <main-navbar />
      <main-sidebar v-if="hasLogin" ref='mychild'/>
      <div
              :style="{ 'min-height': documentClientHeight + 'px','margin-left': leftMenu?(sidebarFold?'64px':'230px'):'0px'}"
              class="site-content__wrapper is_leader"
              v-if="hasLogin"
      >
        <main-content />
      </div>
      <div
              :style="{
						'min-height': documentClientHeight + 'px',
						'margin-left': '0px'
					}"
              class="site-content__wrapper"
              v-if="!hasLogin"
      >
        <main-content />
      </div>
    </template>
  </div>
</template>
<script>

  import MainNavbar from './main-navbar'
  import MainSidebar from './main-sidebar'
  import MainContent from './main-content'
  import loginHttp from '@/utils/login'
  import {mapState} from "vuex";
  import {isURL} from '@/utils/validate'

  export default {
    data () {
      return {
        loading:false,
        typeIdArr:[], //角色类型
        role:'',
        roleId:'',//审核人
        roleNo:'',
        roleUserTypeList:'',
        roleUserType:'',
      }
    },
    components: {
      MainNavbar,
      MainSidebar,
      MainContent
    },
    computed: {
      leftMenu:{
        get() {
          return this.$store.state.common.leftMenu;
        },
      },
      documentClientHeight: {
        get () { return this.$store.state.common.documentClientHeight },
        set (val) { this.$store.commit('common/updateDocumentClientHeight', val) }
      },
      sidebarFold: {
        get () {
          return this.$store.state.common.sidebarFold
        }
      },
      hasLogin: {
        get () {
          return this.$store.state.user.id !== ''  && this.$store.state.user.id !== undefined
        }
      },
      userId: {
        get () { return this.$store.state.user.id },
        set (val) { this.$store.commit('user/updateId', val) }
      },
      userName: {
        get () { return this.$store.state.user.name },
        set (val) { this.$store.commit('user/updateName', val) }
      },
      displayName: {
        get () { return this.$store.state.user.displayName },
        set (val) { this.$store.commit('user/updateDisplayName', val) }
      },
       ...mapState({
              stateData:state=>state.user
          })
    },
    created () {
      this.roleNo =  this.stateData.noRoleId//没有角色权限
      this.loading=true;
      this.getUserInfo();
      var roleData = this.stateData.orgInternalRoleIds //角色类型数组

    },
    mounted () {
      this.resetDocumentClientHeight();
    },
    methods: {
      compare(property){ //排序
          return function(a,b){
              var value1 = a[property];
              var value2 = b[property];
              return value1 - value2;
          }
      },
        fnAddDynamicMenuRoutes(menuList = []) {
            let routes = []
            this.fnAddDynamicMenuRoutesCicle(menuList, routes)
        },
        fnAddDynamicMenuRoutesCicle(menuList = [], routes = []) {
            var temp = []
            let funcList = []
            for (var i = 0; i < menuList.length; i++) {
                let menuItem = menuList[i]
                if (menuItem.children && menuItem.children.length >= 1) {
                    temp = temp.concat(menuItem.list)
                } else if (menuItem.url && /\S/.test(menuItem.url)) {
                    if (menuItem.funcList && menuItem.funcList.length >= 1) {
                        funcList = funcList.concat(menuItem.funcList)
                    }
                    //有明确路由名称的表示静态路由
                    if (menuItem.routeName) {
                        continue
                    }
                    menuItem.url = menuItem.url.replace(/^\//, '')
                    let url = menuItem.url
                    let argIndex = url.indexOf('?')
                    if (argIndex > 0) {
                        url = url.substr(0, argIndex)
                    }
                    let routePath = url.replace('/', '-')
                    var route = {
                        path: routePath,
                        component: null,
                        name: routePath,
                        meta: {
                            menuId: menuItem.menuId,
                            title: menuItem.name,
                            isDynamic: true,
                            isTab: true,
                            iframeUrl: ''
                        }
                    }
                    // url以http[s]://开头, 通过iframe展示
                    if (isURL(menuItem.url)) {
                        route['path'] = `i-${menuItem.menuId}`
                        route['name'] = `i-${menuItem.menuId}`
                        route['meta']['iframeUrl'] = menuItem.url
                    } else {
                        try {
                            route['component'] = _import(`modules/${url}`) || null
                        } catch (e) {
                        }
                    }
                    routes.push(route)
                    sessionStorage.setItem('dynamicMenuRoutes', JSON.stringify(routes || '[]'))
                }
            }
            if (temp.length >= 1) {
                this.fnAddDynamicMenuRoutesCicle(temp, routes)
            }
            if (funcList.length >= 1) {
                this.fnAddDynamicMenuRoutesCicle(funcList, routes)
            }
        },
      // 重置窗口可视高度
      resetDocumentClientHeight () {
        this.documentClientHeight = document.documentElement['clientHeight']
        window.onresize = () => {
          this.documentClientHeight = document.documentElement['clientHeight']
        }
      },
      // 获取当前管理员信息
      getUserInfo () {
        this.loading = false;
      }
    }
  }
</script>
<style lang="scss" scoped>
  .el-table .cell,.el-table th div {
    padding-right: 0;
  }
  // .el-tabs__item:nth-of-type(2) span{
  // 		display: none;
  // }
</style>